import React, { useState } from "react";
import '../styles/Tab.css'; // Import your styles
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

const Tab = ({ code, title, projects, introduction}) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleTab = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="tab">
      <div className="tab-title" onClick={toggleTab}>
        <span className="tab-code">{code}</span> 
        <span className="tab-title-text">{title}</span> 
        <span className="tab-toggle">{isOpen ? "-" : "+"}</span>
      </div>
      {isOpen && (
        <div className="tab-content">
          <div className="introduction-container">
            <p className="introduction">{introduction}</p> {/* Display the category introduction here */}
          </div>
          <div className="projects-container">
          {projects.map((project, index) => (
            <div key={index} className="project-item">
              <Link to={project.link}>
                <img src={project.image} alt={project.title} />
              </Link>
              <div className="project-title">{project.title}</div>
              <span className="skills-hover">
                {project.skills.join(", ")}
              </span>
              <div className="project-description">{project.description}</div>
            </div>
          ))}
          </div>
        </div>
      )}
    </div>
  );
};
export default Tab;